<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="800px"
              scrollable
    >
        <v-card v-if="item">
            <v-toolbar dense :elevation="0">
                <v-toolbar-title>
                    Demographics info for <strong class="text-primary-700">{{item.district_sc}}</strong> district
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width:35px; height:35px" class="mr-0" icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider class="mx-2 mb-4"></v-divider>
            <v-card-text >
                <v-row>
                    <v-col cols="6">
                        <div>
                            <h3>Affluence</h3>
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                    <tr>
                                        <td>Affluence 1 mile:</td>
                                        <td>{{item.affluence_1_mile}}</td>
                                    </tr>
                                    <tr>
                                        <td>Affluence 2 mile:</td>
                                        <td>{{item.affluence_2_mile}}</td>
                                    </tr>
                                    <tr>
                                        <td>Affluence 4 mile:</td>
                                        <td>{{item.affluence_4_mile}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                    <v-col>
                        <div>
                            <h3>Population</h3>
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                    <tr>
                                        <td>Population 1 mile:</td>
                                        <td>{{item.population_1_mile}}</td>
                                    </tr>
                                    <tr>
                                        <td>Population 2 mile:</td>
                                        <td>{{item.population_2_mile}}</td>
                                    </tr>
                                    <tr>
                                        <td>Population 4 mile:</td>
                                        <td>{{item.population_4_mile}}</td>
                                    </tr>
                                    <tr>
                                        <td>Local SC Population:</td>
                                        <td>{{item.local_sc_population}}</td>
                                    </tr>
                                    <tr>
                                        <td>District SC Population:</td>
                                        <td>{{item.district_sc_population}}</td>
                                    </tr>
                                    <tr>
                                        <td>Experian Local SC:</td>
                                        <td>{{item.experian_local_sc}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                </v-row>


            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
	export default {
		name: "demographicInfoDialog",
		data: () => ({
			dialog: false,
			id: null,
			item: null,
		}),
		methods: {
			showDialog: function (id) {
				this.dialog = true;
				this.id = id;
				this.getItem();
			},
			async getItem() {
				const {data} = await this.$http.get(`/demographics/${this.id}`);

				this.item = data;
			},
			closeDialog: function () {
				this.dialog = false;
				this.id = null;
				this.item = null;
				this.$emit('closed');
			},
		},
	}
</script>

<style scoped>

</style>